import React from 'react';
import Skeleton from '@mlb/react-patterns/components/Skeleton/skeleton.tsx';

import {
    AccordionItem,
    Container,
} from './FilterWrapper.styles';

const FilterSkeleton = () => {

    return (
        <Container>
            <AccordionItem
                headline={<Skeleton isLoading={true} width={'100px'} height={'16px'} />}
                showIcon={false}
                isOpen={false}
            />
        </Container>
    );

};

export default FilterSkeleton;
